// UQ-it-IT
module.exports = {
  "forTest": "test for UQ-it-IT",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Look ufficiali",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Elenca per",
  "text_filter": "Filtri",
  "text_styling_book_search_results_number": "{total} risultati",
  "text_active_filters": "Filtri attivi",
  "text_styling_book_clear_all_filters": "Deseleziona tutto",
  "text_styling_book_search_by_feature": "Ricerca per caratteristiche",
  "text_styling_book_search_by_category": "Ricerca per categoria",
  "text_styling_book_staff_customer_filter_all": "Tutto",
  "text_styling_book_search_by_coordinate": "Ricerca per coordinate",
  "text_styling_book_staff_customer_filter_title": "Staff/Cliente",
  "text_styling_book_search_by_height": "Ricerca per altezza",
  "text_styling_book_search_by_hashtag": "Ricerca per hashtag",
  "text_styling_book_staff_customer_filter_customer_styling": "Look dei clienti",
  "text_styling_book_staff_customer_filter_staff_styling": "Look dello staff",
  "text_apply_search_filter": "Applica",
  "text_styling_book_no_results": "Nessun risultato",
  "text_error_title": "Servizio momentaneamente non disponibile",
  "text_503_error_description-1": "Siamo spiacenti, si è verificato un errore.",
  "text_503_error_description-2": "Riprova ad accedere al sito più tardi o ritorna alla pagina precedente utilizzando il pulsante \"Indietro\" del browser.",
  "text_503_error_instruction": "Per qualsiasi domanda, {text_contactus}.",
  "text_styling_book_go_to_top": "Homepage di UNIQLO",
  "text_contactus": "Contattaci",
  "text_wishlist": "Lista dei desideri",
  "text_membership_info": "Account",
  "text_wearing_items": "Indossare articoli",
  "text_color": "Colore",
  "text_size": "Taglia",
  "text_stylehint_non_listed_items_message_01": "Se un prodotto non è incluso nella lista qui sopra, significa che o è esaurito, o non è un prodotto UNIQLO.",
  "text_styling_book_related_styling_title": "Look correlati",
  "text_style_styling_date_update": "Aggiorna",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "{price} €",
  "text_404": "Pagina non trovata",
  "text_official_styling_top_page_link": "Look ufficiali",
  "text_stylehint_top_page_link": "StyleHint",
  "text_breadcrumbs_top": "Homepage di UNIQLO",
  "text_a11y_close": "Chiudi",
  "text_log_in": "Accedi",
  "text_app_update_dialog_cancel": "Annulla",
  "text_menu": "Menu",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. Tutti i diritti riservati.",
  "text_stylehintapp": "App StyleHint",
  "text_styling_book_official_styling_page_title": "Look ufficiali",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Nuovi arrivi",
  "text_styling_book_sort_popular": "I più popolari",
  "text_styling_book_search_by_color": "Ricerca per colore",
  "text_filter_clear_all_category": "Deseleziona tutte le categorie",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Mostra tutto",
  "text_error_description": "Si è verificato un errore di sistema. Riprova o ritorna più tardi.",
  "text_system_error": "Errore di sistema",
  "text_ok": "OK",
  "text_login_required": "Login richiesto",
  "text_login_request": "Vai alla pagina di accesso.",
  "text_error_failed_sort_product": "Impossibile elencare i prodotti con i criteri selezionati. Applica di nuovo l'elenco.",
  "text_error_failed_update_filter_criteria": "Impossibile aggiornare i filtri. Riprova.",
  "text_meta_title_postfix": "| UNIQLO IT",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Donna",
  "text_styling_book_meta_men": "Uomo",
  "text_styling_book_meta_kids": "Bambini",
  "text_styling_book_meta_baby": "Neonati",
  "text_styling_book_official_gender_meta_description": "Sfoglia il nostro lookbook per trovare il look da {gender} perfetto per questa stagione! Acquista i look completi o salva i tuoi preferiti per un secondo momento.",
  "text_styling_book_official_gender_meta_title": "Esplora i look per questa stagione | {gender} | Styling ufficiale {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "Idee di look {uqPostfix} da {gender} 「{filterOptions}」",
  "text_styling_book_official_gender_filter_meta_description": "Scopri idee di look da {gender} 「{filterOptions}」con i prodotti {brand}. Trova l'ispirazione per i tuoi outfit.",
  "text_styling_book_official_detail_meta_title": "Scopri look con「{officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Scopri i nuovi look della stagione con「{officialProducts}」e acquista ora l'outfit completo su {brand}.com!",
  "text_styling_book_stylehint_gender_meta_title": "Trova nuove idee di look | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "Trova nuove idee! Esplora i look da {gender} creati dai nostri clienti e dallo staff {brand} con l'app StyleHint.",
  "text_styling_book_stylehint_filter_meta_title": "Idee di look da {gender} 「{filterOptions}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Outfit di {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Outfit di {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Outfit di {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Scopri come abbinare「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Scopri gli outfit di {staffName}({height}) di {brand}({storeName}). Scopri i look di tendenza creati dal nostro staff.",
  "text_styling_book_stylehint_ins_user_meta_description": "Scopri gli outfit di「{userName}」con i prodotti {brand} per creare nuovi abbinamenti. Scopri come i nostri clienti creano i propri look.",
  "text_styling_book_stylehint_customer_user_meta_description": "Scopri gli outift di {userName} ({height}) con i prodotti {brand}. Scopri i prodotti sullo shop online.",
  "text_styling_book_stylehint_detail_meta_description": "Scopri nuovi look con「{stylehintProducts}」creati dai nostri clienti e dallo staff {brand}. Acquista ora l'outfit completo su {brand}.com!",
  "text_styling_book_stylehint_filter_meta_description": "Scopri「{searchCount}」look di「{filterOptions}」 con i prodotti {brand}. Scopri i nuovi arrivi e i prodotti must have sullo shop online.",
  "text_styling_book_stylehint_styling_id_alt_tag": "Style ID del LOOKBOOK di {brand} con idee di outfit: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "Style ID del LOOKBOOK di {brand} con idee di look: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Scopri idee di look con「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Scopri idee di outfit con「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Looks de {gender}「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Idee di look da {gender}「{feature}」",
  "text_style_model_height": "cm",
  "text_503_error_description": "Siamo spiacenti. Si è verificato un errore. Riprova ad accedere al sito più tardi o ritorna alla pagina precedente utilizzando il pulsante \"Indietro\" del browser.",
  "text_styling_book_meta_official_styling": "Idee per il tuo stile",
  "text_styling_book_meta_stylehint": "Idee per il tuo outfit",
  "text_limited_offer_until_date": "Offerta limitata sino a {date}",
  "text_online_store_exclusive_limited_offer_until_date": "Offerta limitata esclusiva negozio online sino a {date}",
  "text_app_membership_exclusive_limited_offer_until": "Esclusivo per i membri dell’app sino a {date}",
  "text_csoon_early": "Disponibile agli inizi di {month}",
  "text_csoon_mid": "Disponibile da metà {month}",
  "text_csoon_late": "Disponibile alla fine di {month}",
  "text_men": "Uomo",
  "text_women": "Donna",
  "text_kids": "Bambini",
  "text_baby": "Neonati",
  "text_unisex": "Unisex",
  "text_app_membership_exclusive_limited_offer": "Esclusivo per i membri dell’app",
  "text_styling_book_gender_menu_kids_and_baby": "Bambini/Neonati",
  "text_styling_book_meta_kids_and_baby": "",
  "text_a11y_favorites_add": "Aggiungi alla lista dei desideri",
  "text_close": "Chiudi",
  "text_error_wishlist_max": "Non puoi aggiungere l'articolo alla tua wishlist a causa del superamento del limite massimo di 999 articoli.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "Nessuna immagine",
  "text_wearing_size_code01": "Taglia indossata: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "",
  "text_locale_it": "Italiano",
  "text_locale_nl": "",
  "text_product_unavailable": "Il prodotto è fuori produzione.",
  "text_product_display_markdown": "",
  "text_color_white": "Bianco",
  "text_color_gray": "Grigio",
  "text_color_black": "Nero",
  "text_color_pink": "Rosa",
  "text_color_red": "Rosso",
  "text_color_orange": "Arancione",
  "text_color_beige": "Beige",
  "text_color_brown": "Marrone",
  "text_color_yellow": "Giallo",
  "text_color_green": "Verde",
  "text_color_blue": "Blu",
  "text_color_purple": "Viola",
  "text_promotion": "Promozione",
  "text_styling_promotion_hashtag": "Promozione",
  "text_coming_soon": "In arrivo",
  "text_markdown": "Sconti",
  "text_multibuy_markdown": "Multiacquisto, ribasso",
  "text_multibuy_limited_offer_until_date": "Multiacquisto, offerta limitata sino a {date}",
  "text_app_membership_exclusive_multi_buy_until": "",
  "text_app_membership_exclusive_multi_buy": "",
  "text_app_membership_exclusive_limitedoffers_until": "",
  "text_item_preorder_color_size_only": "",
  "text_item_resale_color_size_only": ""
}; // generated at Thu May 30 2024 09:39:59 GMT+0800 (Hong Kong Standard Time)